// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1evzi","newExpiryDate":"styles_newExpiryDate__2L9_s","footer":"styles_footer__j16R8"};